import "./ImageUploader.scss"
import React, { Component } from "react"
import { observer } from "mobx-react"
import { authStore, storefrontStore } from "../stores"
import Modal from "./Modal"
import ImageTerms from "./ImageTerms"

class ImageUploader extends Component {
  state = {
    picker: false,
  }

  handleUpload = e => {
    authStore.uploadProductImage(e).then(upload => {
      // this.handleSelect(upload.customUrl)
    })
  }

  handleSelect = url => {
    this.props.onChange(url)
    this.togglePicker()
  }

  togglePicker = () => {
    this.setState({ picker: !this.state.picker })
  }

  render() {
    return (
      <div className="ImageUploader">
        {this.props.value && (
          <img
            className="ImageUploader_preview"
            src={this.props.value}
            alt=""
          />
        )}
        <div className="ImageUploader_prompt" onClick={this.togglePicker}>
          <h1>+</h1>
          <h5>Upload</h5>
          <p style={{ fontSize: 12 }}>Files supported: png, jpg</p>
        </div>
        {this.state.picker && (
          <Modal onClose={this.togglePicker}>
            {storefrontStore.acceptsDesignCopyright ? (
              <div className="ImageUploader_modal">
                <header className="ImageUploader_header">
                  <h2>Your Uploaded Files</h2>
                  {authStore.store.uploads ? (
                    <p>Select an image below or upload another one.</p>
                  ) : (
                    <p>Upload an image</p>
                  )}
                </header>
                {authStore.store.uploads ? (
                  <ul className="ImageSelector_modal_files">
                    <li>
                      <div className="ImageSelector_modal_upload">
                        <label className="ImageSelector_modal_input">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={this.handleUpload}
                          />
                        </label>
                      </div>
                    </li>
                    {Object.keys(authStore.store.uploads).map(key => (
                      <li key={key}>
                        <div
                          className="ImageSelector_modal_file"
                          onClick={() =>
                            this.handleSelect(
                              authStore.store.uploads[key].customUrl
                            )}>
                          <img
                            src={authStore.store.uploads[key].customUrl}
                            alt=""
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="ImageSelector_standalone">
                    <div className="ImageSelector_modal_upload">
                      <label className="ImageSelector_modal_input">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={this.handleUpload}
                        />
                      </label>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <ImageTerms onAccept={storefrontStore.acceptDesignCopyright} />
            )}
          </Modal>
        )}
      </div>
    )
  }
}

ImageUploader.displayName = "ImageUploader"

export default observer(ImageUploader)



// WEBPACK FOOTER //
// ./src/lib/ImageUploader.js